module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesRomantic.f3a084d.webp";